import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function joinGroup(affectedStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.joinGroup.url, { id: affectedStaffId }))
    .post()
}
